module.exports = __webpack_public_path__ + "6689fef06098983e722eea7e3c6776ca.pdf";